import { InboxInIcon } from "@heroicons/react/outline"
import Input from "../../atoms/input.atom"
import React from "react"
import { Header } from "../../common/header"
import Button from "../../atoms/button.atom"
import * as yup from "yup"
import { validateYup } from "../../template-info/templateUtils"
import { axiosInstance } from "../../../lib/axios"
import { EndpointConfig } from "../../../config"
import { toast } from "react-toastify"
import { getCookie } from "../../../helper/auth"

export const AdminInviteUser = () => {
	const [form, setForm] = React.useState({
		email: ""
	})

	const invite = () => {
		let schema = yup.object().shape({
			email: yup.string().email("Must be a valid email").trim().required("Required")
		})
		validateYup(schema, form)
			.then(() => {
				setErrors({})
				setLoading(true)
				;(async () => {
					const token = getCookie("token")
					await axiosInstance.post(
						EndpointConfig.User,
						{
							email: form.email
						},
						{
							headers: {
								Authorization: `Bearer ${token}`
							}
						}
					)
					setForm({ email: "" })
					toast("User Added")
				})()
					.catch((error) => {
						console.error(error)

						if (error?.response?.data?.error) {
							toast(error.response.data.error)
						} else {
							toast("Something went wrong")
						}
					})
					.finally(() => setLoading(false))
			})
			.catch(setErrors)
	}

	const [loading, setLoading] = React.useState(false)
	const [errors, setErrors] = React.useState({})

	return (
		<div className="flex flex-col">
			<Header IconName={InboxInIcon} subText={"Invite"} mainText={"Add User"} />
			<div className="flex flex-col gap-1 p-4 bg-white rounded">
				<div className="w-1/3">
					<Input
						name="name"
						error={errors?.email}
						value={form.email}
						label={"Email"}
						placeholder={"Email Address"}
						onChange={(e) => setForm({ ...form, email: e.target.value })}
					/>
				</div>

				{loading ? (
					<Button className="w-1/3 text-black bg-red-100 pointer-events-none ">
						Loading
					</Button>
				) : (
					<Button className="w-1/3 " onClick={invite}>
						Add User
					</Button>
				)}
			</div>
		</div>
	)
}
